import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
let UserReminderModel = (_dec = attr('number'), _dec2 = attr('string'), _dec3 = attr('boolean', {
  defaultValue: false
}), _class = class UserReminderModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "send_when_number", _descriptor, this);
    _initializerDefineProperty(this, "send_when_unit", _descriptor2, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "send_when_number", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "send_when_unit", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { UserReminderModel as default };
//# sourceMappingURL=user-reminder.js.map
